var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"item",on:{"click":_setup.emitClick}},[_c('router-link',{class:{ active: _setup.props.active },attrs:{"to":{ name: _setup.props.route }}},[_vm._t("default"),_c('h1',{class:{ hover: _setup.props.hover }},[_vm._v(_vm._s(_setup.translateName))])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }